import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'gnb-item'
})
export default class GnbItem extends Vue {
    @Prop({type:Object}) menuItem!: appbase.cache.TMenuItem
    @Prop({type:Number}) topMenuId!: number
    @Prop({type:String}) userLang!: string

    @Watch('topMenuId')
    get isSelected(){
        return this.menuItem.menuId === this.topMenuId;        
    }

    fnGetMenuName(menuItem: appbase.cache.TMenuItem){
        return (this.userLang && this.userLang.toLowerCase() == 'ko-kr' ? menuItem.menuName : menuItem.menuNameEn)
    }
}